import { useMemo } from 'react';
import { useClients } from '@axo/shared/data-access/hooks';
import { getLocalPartOfEmail } from '../../utils/getLocalPartOfEmail';

export function useAvailableClients() {
  const clients = useClients();

  return useMemo(() => {
    if (!clients.data?.Items) {
      return [];
    }

    return [
      ...clients.data.Items.map((client) => ({
        ...client,
        DisplayName: getLocalPartOfEmail(client.Email),
      })).sort((a, b) => (a.DisplayName < b.DisplayName ? -1 : 1)),
    ];
  }, [clients.data?.Items]);
}
